import script from "./DeleteComment.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteComment.vue?vue&type=script&setup=true&lang=js"

import "./DeleteComment.vue?vue&type=style&index=0&id=1c332549&lang=scss"

const __exports__ = script;

export default __exports__